import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class FinalizeIssueCommand extends AbstractCommand<string> {

    public name: CommandName = CommandName.FINALIZE_ISSUE;

    public tags = ['entity', 'change', 'issue'];

    constructor(payload: string) {
        super('issue', payload, payload);
    }
}